import React, { useState } from 'react';
import { IAppProps } from '@interfaces/App.interface';
import { Grid, Typography } from '@ts/storybook';
import KPI from '@components/KPI';

interface DashboardProps extends IAppProps {}

const DashboardProductivityMockPage = (props: DashboardProps) => {
  const [value, setValue] = useState('today');
  const [slot, setSlot] = useState('week');

  const firstColor = '#201b50';
  const lastColor = '#077bc0';

  //#region Handlers
  const onChangeSlot = (item: any, type: string) => {
    setSlot(type);
  };
  //#endregion

  //#region MockData
  const data1 = {
    xaxis: {
      categories: ['Staff', 'Contractor A', 'Contractor B', 'Contractor C', 'Inspector Services Co', 'Others'],
    },
    series: [
      {
        name: 'PERSONNEL BY COMPANY',
        data: [73, 4, 146, 255, 2, 6],
      },
    ],
  };
  const data2 = {
    xaxis: {
      categories: ['Managers', 'EHS', 'OtherStaff', 'Contractors', 'Lone Workers', 'Others'],
    },
    series: [
      {
        name: 'PERSONNEL ON SITE BY CATEGORY',
        data: [8, 4, 6, 230, 64, 45],
      },
    ],
  };

  const data3 = {
    xaxis: {
      categories: ['Help button', 'Impact', 'In risk zones', 'No link', 'No movement', 'Battery <10%', 'Out of perimeter'],
    },
    series: [
      {
        name: 'HSE Events',
        data: [3, 4, 26, 5, 12, 10, 2],
      },
    ],
  };

  const dataTime1 = {
    series: [
      {
        name: 'Staff',
        data: [
          {
            x: 'Subproject 3452-DWE',
            y: [new Date('2019-03-05').getTime(), new Date('2019-03-08').getTime()],
          },
          {
            x: 'Subproject 3452-AA',
            y: [new Date('2019-03-02').getTime(), new Date('2019-03-05').getTime()],
          },
          {
            x: 'Subproject 3452-AA',
            y: [new Date('2019-03-05').getTime(), new Date('2019-03-07').getTime()],
          },
          {
            x: 'Subproject 556',
            y: [new Date('2019-03-03').getTime(), new Date('2019-03-09').getTime()],
          },
          {
            x: 'Subproject 556-Bis',
            y: [new Date('2019-03-08').getTime(), new Date('2019-03-11').getTime()],
          },
          {
            x: 'Subproject 42-B',
            y: [new Date('2019-03-11').getTime(), new Date('2019-03-16').getTime()],
          },
          {
            x: 'Subproject 3452-DWE',
            y: [new Date('2019-03-01').getTime(), new Date('2019-03-03').getTime()],
          },
        ],
      },
      {
        name: 'Contractor Company B',
        data: [
          {
            x: 'Subproject 3452-DWE',
            y: [new Date('2019-03-02').getTime(), new Date('2019-03-05').getTime()],
          },
          {
            x: 'Subproject 556-Bis',
            y: [new Date('2019-03-06').getTime(), new Date('2019-03-16').getTime()],
            goals: [
              {
                name: 'Task  422',
                value: new Date('2019-03-10').getTime(),
                strokeColor: '#CD2F2A',
              },
            ],
          },
          {
            x: 'Subproject 3452-AA',
            y: [new Date('2019-03-03').getTime(), new Date('2019-03-07').getTime()],
          },
          {
            x: 'Training and certificications',
            y: [new Date('2019-03-20').getTime(), new Date('2019-03-22').getTime()],
          },
          {
            x: 'Subproject 3452-DWE',
            y: [new Date('2019-03-10').getTime(), new Date('2019-03-16').getTime()],
          },
        ],
      },
      {
        name: 'Contractor Company B',
        data: [
          {
            x: 'Subproject 3452-AA',
            y: [new Date('2019-03-10').getTime(), new Date('2019-03-17').getTime()],
          },
          {
            x: 'Subproject 42-B',
            y: [new Date('2019-03-05').getTime(), new Date('2019-03-09').getTime()],
            goals: [
              {
                name: 'Task  422',
                value: new Date('2019-03-07').getTime(),
                strokeColor: '#CD2F2A',
              },
            ],
          },
        ],
      },
    ],
  };
  const dataTime2 = {
    series: [
      {
        name: 'Staff labour',
        data: [
          {
            x: 'Road Km 22-23',
            y: [new Date('2019-03-05').getTime(), new Date('2019-03-08').getTime()],
          },
          {
            x: 'Road Km 67- 67,300',
            y: [new Date('2019-03-02').getTime(), new Date('2019-03-05').getTime()],
          },
          {
            x: 'Road Km 68- 68,100',
            y: [new Date('2019-03-05').getTime(), new Date('2019-03-07').getTime()],
          },
          {
            x: 'Road Km 68',
            y: [new Date('2019-03-03').getTime(), new Date('2019-03-09').getTime()],
          },
          {
            x: 'Road Km 69',
            y: [new Date('2019-03-08').getTime(), new Date('2019-03-11').getTime()],
          },
          {
            x: 'Road Km 69,100',
            y: [new Date('2019-03-11').getTime(), new Date('2019-03-16').getTime()],
          },
          {
            x: 'Road Km 22-23',
            y: [new Date('2019-03-01').getTime(), new Date('2019-03-03').getTime()],
          },
        ],
      },
      {
        name: 'Contractor Company B',
        data: [
          {
            x: 'Road Km 22-23',
            y: [new Date('2019-03-02').getTime(), new Date('2019-03-05').getTime()],
          },
          {
            x: 'Road Km 69',
            y: [new Date('2019-03-06').getTime(), new Date('2019-03-16').getTime()],
            goals: [
              {
                name: 'Task  422',
                value: new Date('2019-03-10').getTime(),
                strokeColor: '#CD2F2A',
              },
            ],
          },
          {
            x: 'Road Km 67- 67,300',
            y: [new Date('2019-03-03').getTime(), new Date('2019-03-07').getTime()],
          },
          {
            x: 'Others',
            y: [new Date('2019-03-20').getTime(), new Date('2019-03-22').getTime()],
          },
          {
            x: 'Road Km 22-23',
            y: [new Date('2019-03-10').getTime(), new Date('2019-03-16').getTime()],
          },
        ],
      },
      {
        name: 'Contractor Company B',
        data: [
          {
            x: 'Road Km 67- 67,300',
            y: [new Date('2019-03-10').getTime(), new Date('2019-03-17').getTime()],
          },
          {
            x: 'Road Km 69,100',
            y: [new Date('2019-03-05').getTime(), new Date('2019-03-09').getTime()],
            goals: [
              {
                name: 'Task  422',
                value: new Date('2019-03-07').getTime(),
                strokeColor: '#CD2F2A',
              },
            ],
          },
        ],
      },
    ],
  };

  //#endregion

  return (
    <Grid container size={12} spacing={3} p={4}>
      {/* row 1 */}
      {/* <Grid size={{ xs: 12 }} sx={{ mb: -2.25 }}>
        <Typography variant="h5">Dashboard</Typography>
      </Grid> */}
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <KPI.KPICard title="Personnel on site" dataCard={{ value: 980, oldValue: 970 }} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <KPI.KPICard title="On-time ratio" dataCard={{ value: 98, oldValue: 97.5 }} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <KPI.KPICard title="Warnings open" dataCard={{ value: 21, oldValue: 32 }} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <KPI.KPICard title="Notifications in 24h" dataCard={{ value: 5, oldValue: 10 }} />
      </Grid>

      {/* row 2 */}
      <Grid size={{ xs: 12, md: 6 }}>
        <KPI.BarChart
          {...props}
          options={{ color: '#0a8103', title: 'Personnel by company' }}
          dataChart={data1}
          loading={false}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <KPI.BarChart
          {...props}
          options={{ color: '#aef32e', title: 'Personnel on site by category' }}
          dataChart={data2}
          loading={false}
        />
      </Grid>

      {/* row 3 */}
      <Grid container rowSpacing={1} columnSpacing={2.75} size={12}>
        <Grid size={{ xs: 12 }}>
          <KPI.MainCard content={false}>
            <Grid size={{ xs: 12 }} ml={2}>
              <Typography variant="h5" className="font-medium" text="Deployed team by zone" color="primary" />
            </Grid>
            <Grid size={{ xs: 12 }} className="p-[18px]">
              <KPI.StackedBarChart />
            </Grid>
          </KPI.MainCard>
        </Grid>
      </Grid>

      {/* row 4*/}
      <Grid size={{ xs: 12, md: 6 }}>
        <KPI.ColumnsWithMarkersChart {...props} title={'Personnel deployed on site'} loading={false} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <KPI.GroupedStackedColumns {...props} title={'Time in Production Zone'} />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <KPI.ColumnsWithNegativeChart {...props} title={'Time in Production Zone'} />
      </Grid>

      {/* row 5 */}
      <Grid size={{ xs: 12, md: 6, lg: 6 }}>
        <KPI.TimeChart
          {...props}
          id={'2time'}
          isMock
          loading={false}
          title={'Deployed personnel by location'}
          slot={slot}
          dataChart={dataTime2}
          onChangeSlot={v => onChangeSlot(null, v)}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }}>
        <KPI.TimeChart
          {...props}
          id={'1time'}
          isMock
          loading={false}
          title={'Teams assigned per subproject and time'}
          slot={slot}
          dataChart={dataTime1}
          onChangeSlot={v => onChangeSlot(null, v)}
        />
      </Grid>

      {/* row 5 */}
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }} pt={0}>
          <KPI.MainCard content={false}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid ml={2}>
                <Typography variant="h5" color="primary" className="font-medium" text="Time dedication" />
              </Grid>
              <Grid />
            </Grid>
            <KPI.TasksTable isTimeDedicated />
          </KPI.MainCard>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default DashboardProductivityMockPage;
